import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Button      from '@material-ui/core/Button/Button'
import Card        from '@material-ui/core/Card/Card'
import CardActions from '@material-ui/core/CardActions/CardActions'
import CardContent from '@material-ui/core/CardContent/CardContent'
import CardHeader  from '@material-ui/core/CardHeader/CardHeader'
import Grid        from '@material-ui/core/Grid'

import { AccountType }                                   from '../../api'
import { getStudent, getTeacher }                        from '../../project-utils'
import { isTeacher }                                     from '../../project-utils/permissions'
import { deepOverride, stopNestedSubmissionBubbling }    from '../../utils'
import withAccountType, { InjectedWithAccountTypeProps } from '../hocs/withAccountType'
import { ValidateTypeField }                             from '../molecules'

interface AddCoupleFormProps {
  teacherType: AccountType
  studentType: AccountType
  onSubmit: any
  automaticMatch: boolean
}

const initState = {
  valid: {
    teacher: false,
    student: false,
  },

  value: {
    teacher: '',
    student: '',
  }
}

type Props =
  InjectedWithAccountTypeProps
  & AddCoupleFormProps

class CoupleAddForm extends React.Component<Props, typeof initState> {
  public state = initState

  public render () {
    const { accountType } = this.props

    const common = {
      /* big boi ts at it again, 'string is not assignable to type "dense" | ... ' */
      margin:         'dense' as 'dense',
      fullWidth:      true,
      idleDelay:      500,
      onInvalidation: this.handleInvalidation,
      onValidation:   this.handleValidation,
      onChange:       this.handleChange,
    }

    const readyForSubmission = this.determineValidity()

    const teacherAccountType = getTeacher(accountType as AccountType)
    const studentAccountType = getStudent(accountType as AccountType)

    const title =
      (
        <FormattedMessage
          id={'generic.addStudentTeacherCouple'}
          values={{ teacher: teacherAccountType, student: studentAccountType }}
        />
      )

    return (
      <Card>
        <CardHeader title={title} />
        <form onSubmit={stopNestedSubmissionBubbling(this.proxySubmit)}>
          <CardContent>
            <Grid
              container
              justify={'space-between'}
              spacing={16}
            >
              <Grid item xs={12} md={6}>
                <ValidateTypeField
                  fullWidth
                  value={this.state.value.teacher}
                  accountType={teacherAccountType}
                  label={teacherAccountType}
                  name={'teacher'}
                  InputLabelProps={{ shrink: true }}
                  {...common}
                  noValidate={this.props.automaticMatch}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <ValidateTypeField
                  fullWidth
                  value={this.state.value.student}
                  accountType={studentAccountType}
                  label={studentAccountType}
                  name={'student'}
                  InputLabelProps={{ shrink: true }}
                  {...common}
                  noValidate={this.props.automaticMatch}
                />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions>
            <Button
              disabled={!readyForSubmission}
              color={'primary'}
              type={'submit'}
            >
              <FormattedMessage id={'buttonActions.add'} />
            </Button>
          </CardActions>
        </form>
      </Card>
    )
  }

  private handleChange = ({ target: { value, name } }) => {
    this.setState(state => deepOverride(
      state,
      { value: { [ name ]: value } }
    ))
  }

  private handleValidation = accountType => {
    this.setState(
      state =>
        isTeacher(accountType)
          ?
          deepOverride(
            state,
            {
              valid: { teacher: true },
            }
          )
          :
          deepOverride(
            state,
            {
              valid: { student: true },
            }
          )
    )
  }

  private handleInvalidation = accountType => {
    this.setState(
      state =>
        isTeacher(accountType)
          ?
          deepOverride(
            state,
            {
              valid: { teacher: false },
            }
          )
          :
          deepOverride(
            state,
            {
              valid: { student: false },
            }
          )
    )
  }

  private determineValidity = () => {
    const { valid } = this.state

    return valid.teacher && valid.student
  }

  private getValues = () => {
    const { value } = this.state

    return {
      teacher: value.teacher,
      student: value.student,
    }
  }

  private reset = () => {
    this.setState(initState)
  }

  private proxySubmit = (e: any) => {
    e.preventDefault()

    if (
      document.activeElement
      && document.activeElement instanceof HTMLElement
    ) {
      document.activeElement.blur()
    }

    this.reset()
    this.props.onSubmit(this.getValues())
  }
}

export default withAccountType(CoupleAddForm)



// WEBPACK FOOTER //
// ./src/components/forms/CoupleAddForm.tsx